import type { v4, Manifest } from '@sap/ux-specification-types';
import { syncRule, validity } from '../../../common/decoration/decorators';
import { getGroupedActionsPathForOP, getActionsPathForOP } from '../../application';
import { addPatternForBindingChangeOfEnumOPV4 } from '../../../common/decoration/control';
import type { FormAction } from './ObjectPageForm';
import type { CustomFormActionOP } from './ObjectPageFormAction';
import { exportActionMenuAction, exportActionMenuDefaultAction, exportActionMenuMenu } from '../actions';
export class ObjectPageToolBarActionBase implements v4.ObjectPageToolBarActionBase {
    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    enableOnSelect?: v4.SelectType;
}

export class ObjectPageToolBarAction extends ObjectPageToolBarActionBase implements v4.ObjectPageToolBarAction {
    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}

export class ObjectPageToolBarActionGroup implements v4.ObjectPageToolBarActionGroup {
    [key: string]: ObjectPageToolBarActionBase | number | v4.ActionPriority;

    @syncRule({
        manifest: {
            path: getGroupedActionsPathForOP
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getGroupedActionsPathForOP
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}

/**
 * Sync class for Position
 */
export class CustomActionPositionOP implements v4.CustomActionPositionOP {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey: string): string =>
                getActionsPathForOP(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    anchor?: string;
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey: string): string =>
                getActionsPathForOP(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    placement: v4.ActionPlacement;
}

export class CustomActionOPBase implements v4.CustomActionElement {
    @syncRule({
        manifest: {
            path: getActionsPathForOP,
            export: exportActionMenuMenu
        }
    })
    @validity({
        since: '1.84.0'
    })
    menu: string[];

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    text: string;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    position: CustomActionPositionOP;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    requiresSelection?: boolean;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        },
        generate: addPatternForBindingChangeOfEnumOPV4
    })
    @validity({
        since: '1.84.0'
    })
    visible?: boolean;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        },
        generate: addPatternForBindingChangeOfEnumOPV4
    })
    @validity({
        since: '1.84.0'
    })
    enabled?: boolean;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}

export class CustomTableActionOP extends CustomActionOPBase implements v4.CustomTableActionOP {
    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    press: string;
}

export class ObjectPageCustomActionMenu extends CustomActionOPBase implements v4.ObjectPageCustomActionMenu {
    @syncRule({
        manifest: {
            path: getActionsPathForOP,
            export: exportActionMenuAction
        }
    })
    @validity({
        since: '1.84.0'
    })
    actions?: ObjectPageCustomActionMenuActions;

    @syncRule({
        manifest: {
            path: getActionsPathForOP,
            export: exportActionMenuDefaultAction
        }
    })
    @validity({
        since: '1.84.0'
    })
    defaultAction?: string;
}

export class ObjectPageCustomActionMenuActions implements v4.ObjectPageCustomActionMenuActions {
    [id: string]: CustomTableActionOP | ObjectPageToolBarAction | FormAction | CustomFormActionOP;
}

export class ObjectPageToolBarActions implements v4.ObjectPageToolBarActions {
    [key: string]:
        | ObjectPageToolBarAction
        | CustomTableActionOP
        | ObjectPageCustomActionMenu
        | ObjectPageToolBarActionGroup;
}
